import React, { useEffect } from 'react'

import { Linking } from 'react-native'
import { Logo, Spinner } from '../App/Components'
import { StyledScrollView } from '../App/Components/AppContainer'
import { Calendar } from '../Calendar/Calendar/Calendar'
import { useParams } from '../Router'
import { getCustomerSession } from '../cookies/session.cookies'
import { customerPortalLinks } from '../App/Util/customerPortalUrl'
import { EditOverviewHeader } from './components/EditOverviewHeader/EditOverviewHeader'
import { useAppDispatch, useAppSelector } from '../store/hooks'
import { setUpdatePreviousAppointment } from '../Appointment/store/Actions'
import previousAppointmentsClient from '../PreviousAppointments/Client/Client'
import { useShowError } from '../ErrorPage/useShowError'

export const MoveAppointment = () => {
  const { establishmentId, previousAppointmentId } =
    useParams<{ [key: string]: string }>()
  const dispatch = useAppDispatch()
  const showError = useShowError()

  const { settings, editPreviousAppointment } = useAppSelector((state) => ({
    settings: state.settings.values,
    editPreviousAppointment: state.appointment.editPreviousAppointment,
  }))

  useEffect(() => {
    if (editPreviousAppointment) return

    const session = getCustomerSession(establishmentId)
    if (!session) {
      Linking.openURL(
        customerPortalLinks.login(establishmentId, window.location.href)
      )
      return
    }

    previousAppointmentsClient
      .getPreviousAppointments(establishmentId, session.email, session.token)
      .then(({ appointments }) => {
        const appointment = appointments.find(
          (a) => a.id === Number(previousAppointmentId)
        )
        if (appointment) {
          dispatch(setUpdatePreviousAppointment(appointment))
        } else {
          showError(
            'MoveAppointment',
            `Appointment ${previousAppointmentId} not found`
          )
        }
      })
      .catch((err) => showError('MoveAppointment', err))
  }, [establishmentId, previousAppointmentId])

  if (!settings || !editPreviousAppointment) {
    return <Spinner />
  }

  return (
    <StyledScrollView>
      <Logo />
      <EditOverviewHeader
        establishmentId={establishmentId}
        settingValues={settings}
        prevAppointment={editPreviousAppointment}
      />
      <Calendar
        settings={settings}
        previousAppointment={editPreviousAppointment}
      />
    </StyledScrollView>
  )
}
